export enum ORDER_STATUS_MAP {
  ALL = 'all',
  SUBMITTED = 'submitted',
  ON_HOLD = 'on hold',
  SCHEDULED = 'scheduled',
  PICKED_UP = 'picked up',
  DELIVERED = 'delivered',
  CANCELED = 'canceled',
}
